module.exports = __webpack_public_path__ + "static/media/footer-email-icon.541118d6.png";